import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { prepareBillNotes, reverseArabicAndEnglish } from "./utilies";
import moment from "moment";
import { CairoBold } from "./vfs_noto"
// import { DroidKufiBold } from "./vfs_fonts";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

window.pdfMake.vfs["Cairo-ExtraBold.ttf"] = CairoBold;
// window.pdfMake.vfs["DroidKufi-Bold.ttf"] = DroidKufiBold;
pdfMake.fonts = {
    CairoBold: {
        normal: "Cairo-ExtraBold.ttf",
        bold: "Cairo-ExtraBold.ttf",
    },
    // DroidKufiRegular: {
    //     normal: "DroidKufi-Regular.ttf",
    //     bold: "DroidKufi-Bold.ttf",
    // },
};
export const Invoice80Maker = (obj) => {
    // ----------------------------------------------------
    // تنسيق الأرقام
    // ----------------------------------------------------
    const money = (value) => {
        return Number(value || 0).toFixed(2);
    };
    // ----------------------------------------------------
    // خلية جدول
    // ----------------------------------------------------
    const cell = (text, options = {}) => {
        return {
            text: text === null || text === undefined ? "" : String(text),
            fontSize: options.fontSize || 8,
            bold: options.bold || false,
            alignment: options.alignment || "center",
            margin: options.margin || [1, 2, 1, 2],
            // rtl: options.rtl !== false
            rtl: true
        };
    };
    // ----------------------------------------------------
    // بيانات الأصناف
    // ----------------------------------------------------
    const itemRows = [
        // رأس الجدول
        [
            //   cell("الوحدة", {
            //     bold: true,
            //     fontSize: 7
            //   }),

            cell(reverseArabicAndEnglish("الإجمالي"), {
                bold: true,
                fontSize: 10,
                margin: [0, 0],
            }),
            cell(reverseArabicAndEnglish("السعر"), {
                bold: true,
                fontSize: 10,
                margin: [0, 0],
            }),
            cell(reverseArabicAndEnglish("الكمية"), {
                bold: true,
                fontSize: 10,
                margin: [0, 0],
            }),
            cell(reverseArabicAndEnglish("اسم الصنف"), {
                bold: true,
                fontSize: 8,
                margin: [0, 0],
            }),
        ]
    ];
    // ----------------------------------------------------
    // الأصناف
    // ----------------------------------------------------
    const showBarode = obj?.invSet?.dsplyColmSerialnumb ?? 0;
    const showInvNotes = obj?.invSet?.display_InvNotes ?? false;

    (obj.items || []).forEach((item) => {
        itemRows.push([
            cell(money(item.tot_net_curr), {
                fontSize: 11,
                margin: [0, 0],
            }),
            cell(money(item.new_exchange_price), {
                fontSize: 11,
                margin: [0, 0],
            }),
            cell(item.val1 || 1, {
                fontSize: 11,
                margin: [0, 0],
            }),
            cell(
                showBarode ? `${item.barcode}\n${prepareBillNotes(item.symbol, 22)}` :
                    prepareBillNotes(item.symbol, 22),
                {
                    fontSize: 9,
                    alignment: "right",
                    margin: [0, 0],
                }
            ),
        ]);

    });
    // ----------------------------------------------------
    // عنوان نوع الفاتورة
    // ----------------------------------------------------
    const invoiceTitle = {
        table: {
            widths: ["*"],
            body: [
                [
                    {
                        text: obj?.tot?.tax_no_cust === ""
                            ? reverseArabicAndEnglish("فاتورة  ضريبية مبسطة")
                            : reverseArabicAndEnglish("فاتورة  ضريبية"),
                        fontSize: 10,
                        bold: true,
                        alignment: "center",
                        margin: [1, 2, 1, 2]
                    }
                ]

            ]
        },
        layout: {
            hLineWidth: () => 0.7,
            vLineWidth: () => 0.7,
            hLineColor: () => "#000000",
            vLineColor: () => "#000000"
        },
        margin: [0, 1, 0, 1]
    };
    // ====================================================
    // تعريف المستند
    // ====================================================
    const docDefinition = {
        pageSize: {
            width: 260,
            // width: 226.77,
            height: "auto"
        },
        pageMargins: [
            9,
            8,
            9,
            8
        ],
        // --------------------------------------------------
        // اتجاه عربي
        // --------------------------------------------------
        defaultStyle: {
            font: "CairoBold",
            fontSize: 8,
            alignment: "center",
            lineHeight: 1.05,

        },
        content: [
            // =================================================
            // الشعار
            // =================================================
            {
                image: obj.imgSrc
                    ? obj.imgSrc
                    : "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=",
                width: 80,
                height: 80,
                margin: [0, 0, 0, -5]
            },
            {
                text: prepareBillNotes(obj?.found?.nameA, 42),
                fontSize: 11,
                bold: true,
                alignment: "center",
                margin: [0, 1, 0, 1]
            },
            // =================================================
            // الاسم الإنجليزي
            // =================================================
            {
                text: prepareBillNotes(obj?.found?.nameE, 42),
                fontSize: 10,
                bold: true,
                alignment: "center",
                margin: [0, 0, 0, 4]
            },
            // =================================================
            // المدينة
            // =================================================
            {
                // text: invoice.city || "جدة",
                text: prepareBillNotes(obj?.found?.Address, 42),
                fontSize: 10,
                bold: true,
                alignment: "right",
                margin: [0, 0, 0, 1]
            },
            // =================================================
            // الرقم الضريبي
            // =================================================
            {
                columns: [
                    {
                        text: obj?.found?.tax_no || "0000",
                        width: "*",
                        alignment: "left",
                        fontSize: 11,
                        bold: true
                    },
                    {
                        text: prepareBillNotes("الرقم الضريبي"),
                        width: "*",
                        alignment: "right",
                        fontSize: 10,
                        bold: true
                    }
                ],
                margin: [0, 0, 0, 1]
            },
            // =================================================
            // السجل التجاري
            // =================================================
            {
                columns: [

                    {
                        text: prepareBillNotes(obj?.found?.bsn_no),
                        width: "*",
                        alignment: "left",
                        fontSize: 11,
                        bold: true
                    },
                    {
                        text: "السجل التجاري",
                        width: "*",
                        alignment: "right",
                        fontSize: 10,
                        bold: true
                    }
                ],

                margin: [0, 0, 0, 1]
            },
            // =================================================
            // عنوان الفاتورة
            // =================================================
            invoiceTitle,
            // =================================================
            // معلومات الفاتورة
            // =================================================
            {
                table: {
                    widths: [
                        "*",
                        72
                    ],
                    body: [

                        [
                            cell(obj?.tot?.id, {
                                fontSize: 12,
                                bold: true,
                                margin: [0, 0],
                            }),

                            cell(prepareBillNotes("رقم الفاتورة"), {
                                fontSize: 9,
                                bold: true,
                                alignment: "right",
                                margin: [0, 0],
                            })
                        ],
                        [
                            cell(moment(obj?.tot?.date).format("YYYY-MM-DD") + " " +
                                moment(obj?.tot?.date).format(" h:mm A"), {
                                fontSize: 10,
                                bold: true,
                                margin: [0, 0],
                            }),
                            cell(prepareBillNotes("تاريخ الفاتورة"), {
                                fontSize: 9,
                                bold: true,
                                alignment: "right",
                                margin: [0, 0],
                            })
                        ],
                        [
                            cell(prepareBillNotes(obj?.tot?.cust_name, 23), {
                                fontSize: 8,
                                margin: [0, 0],
                            }),
                            cell(reverseArabicAndEnglish("اسم العميل"), {
                                fontSize: 9,
                                bold: true,
                                alignment: "right",
                                margin: [0, 0],
                            })
                        ],
                        [
                            cell(prepareBillNotes(obj?.tot?.cust_mobile, 23), {
                                fontSize: 8,
                                margin: [0, 0],
                            }),

                            cell(reverseArabicAndEnglish("بيانات العميل"), {
                                fontSize: 8,
                                bold: true,
                                alignment: "right",
                                margin: [0, 0],
                            })
                        ],
                        [
                            cell(reverseArabicAndEnglish(obj?.tot?.tax_no_cust), {
                                fontSize: 8,
                                margin: [0, 0],
                            }),

                            cell(reverseArabicAndEnglish("الرقم الضريبي"), {
                                fontSize: 8,
                                bold: true,
                                alignment: "right",
                                margin: [0, 0],
                            })
                        ]

                    ]
                },
                layout: {
                    hLineWidth: () => 0.7,
                    vLineWidth: () => 0.7,
                    hLineColor: () => "#000",
                    vLineColor: () => "#000"
                },
                margin: [0, 1, 0, 1]
            },
            // =================================================
            // جدول الأصناف
            // =================================================
            {
                table: {
                    widths: ["auto", "auto", "auto", "*"],
                    body: itemRows
                },
                layout: {
                    hLineWidth: () => 0.7,
                    vLineWidth: () => 0.7,
                    hLineColor: () => "#000",
                    vLineColor: () => "#000"
                },
                margin: [0, 0, 0, 1]
            },
            // =================================================
            // الإجمالي
            // ================================================
            {
                table: {
                    widths: [
                        90, "*"
                        // 90
                    ],
                    body: [
                        [
                            cell(((obj?.tot?.tot_net - obj?.tot?.amountOfVat + obj?.tot?.discount) - parseFloat(obj?.tot?.tab3Vat ?? 0))?.toFixed(2), {
                                fontSize: 12,
                                bold: true,
                                margin: [0, 0],
                            }),

                            cell(prepareBillNotes("الإجمالي قبل الضريبة"), {
                                fontSize: 9,
                                bold: true,
                                alignment: "right",
                                margin: [0, 0],
                            })
                        ],


                        [
                            cell(money(obj?.tot?.discount), {
                                fontSize: 12,
                                bold: true,
                                margin: [0, 0],
                            }),

                            cell(prepareBillNotes("مجموع الخصومات "), {
                                fontSize: 9,
                                bold: true,
                                alignment: "right",
                                margin: [0, 0],
                            })
                        ],

                        [
                            cell((obj?.tot?.tot_net - obj?.tot?.amountOfVat + obj?.tot?.discount), {
                                fontSize: 12,
                                bold: true,
                                margin: [0, 0],
                            }),

                            cell(prepareBillNotes("الإجمالي الخاضع للضريبة"), {
                                fontSize: 9,
                                bold: true,
                                alignment: "right",
                                margin: [0, 0],
                            })
                        ],
                        [obj?.tot?.tab3Vat > 0 ?
                            cell(money(obj?.tot?.amountOfVat), {
                                fontSize: 12,
                                bold: true,
                                margin: [0, 0],
                            }) : {},
                        obj?.tot?.tab3Vat > 0 ?
                            cell("%100" + reverseArabicAndEnglish("مجموع ضريبة التبغ"), {
                                fontSize: 9,
                                bold: true,
                                alignment: "right",
                                margin: [0, 0],
                            }) : {},
                        ],
                        [
                            cell(money(obj?.tot?.amountOfVat), {
                                fontSize: 12,
                                bold: true,
                                margin: [0, 0,0,0],
                            }),

                            cell("(15%)" + "  " + prepareBillNotes("إجمالي الضريبة"), {
                                fontSize: 9,
                                bold: true,
                                alignment: "right",
                                margin: [0, 0,0,0],
                            })
                        ],
                        [
                            cell(money(obj?.tot?.tot_net), {
                                fontSize: 10,
                                bold: true,
                                margin: [0, 0],
                            }),

                            cell(reverseArabicAndEnglish("الاجمالي شامل الضريبه"), {
                                fontSize: 9,
                                bold: true,
                                alignment: "right",
                                margin: [0, 0],
                            })
                        ]
                    ]
                },
                layout: {
                    hLineWidth: () => 0.7,
                    vLineWidth: () => 0.7,
                    hLineColor: () => "#000",
                    vLineColor: () => "#000"
                },
                margin: [0, 1, 0, 1]
            },
            // =================================================
            // المدفوع والمتبقي
            // =================================================
            {
                table: {
                    widths: [
                        "*",
                        "*"
                    ],
                    body: [

                        [
                            {
                                text: (obj?.tot?.tot_net?.toFixed(2) - obj?.tot?.paid).toFixed(2) + "   " + "متبقي",
                                fontSize: 10,
                                bold: true,
                                alignment: "center",
                                margin: [0, 1, 0, 1]
                            },
                            {
                                text: money(obj?.tot?.paid) + "   " + "مدفوع",
                                fontSize: 10,
                                bold: true,
                                alignment: "center",
                                margin: [1, 2, 1, 2]
                            },
                        ]

                    ]
                },

                layout: {
                    hLineWidth: () => 0.7,
                    vLineWidth: () => 0.7,
                    hLineColor: () => "#000",
                    vLineColor: () => "#000"
                },
                margin: [0, 0, 0, 1]
            },
            // QR ZATCA
            // =================================================
            (obj?.Step_inv2 && obj.tot?.ZatcaQR) ? {
                qr: obj.tot?.ZatcaQR,
                fit: 220,
                alignment: "center",
                accLevel: "M",
                margin: [0, 5, 0, 5]
            } : {
                image: `data:image/jpeg;base64,${obj?.inv?.qr_image}`,
                height: 120,
                width: 120,
            },
            // =================================================
            // المستخدم
            // =================================================
            {
                text: reverseArabicAndEnglish(obj?.tot?.sales_emp_name),
                fontSize: 8,
                alignment: "left",
                margin: [0, 0, 0, 1]
            },
            // =================================================
            // أسفل الفاتورة
            // =================================================
            showInvNotes ? {
                text: prepareBillNotes(obj?.inv?.notes, 45),
                font: "CairoBold",
                fontSize: 10,
                bold: true,
                margin: [0, 0, 0, 0],
                alignment: "right",
            } : {},
            {
                text: prepareBillNotes(obj?.found?.BillNotes, 45),
                font: "CairoBold",
                fontSize: 10,
                bold: true,
                margin: [0, 0, 0, 0],
                alignment: "right",
            },


        ]
    };
    // ====================================================
    // إنشاء PDF
    // ====================================================
    return docDefinition;

};